import React from 'react';
import { useAppKit } from '@reown/appkit/react';

// ConnectWalletButton component using normal button with AppKit hooks
export default function ConnectWalletButton() {
    const { open } = useAppKit();

    const handleConnect = () => {
        try {
            // Open the modal with connect view for ethereum wallets
            open({ view: "Connect", namespace: "eip155" });
        } catch (error) {
            console.error('Failed to open wallet connection modal:', error);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px'
        }}>
            <button 
                onClick={handleConnect}
                className="connectWallet-button"
                style={{
                    backgroundColor: '#034807',
                    color: '#4cf038',
                    padding: '12px 20px',
                    fontSize: '16px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    margin: '5px auto',
                    transition: 'background-color 0.3s ease',
                    maxWidth: '380px',
                    display: 'block',
                    textTransform: 'uppercase',
                    width: '100%',
                    fontFamily: 'inherit',
                    fontWeight: 'normal',
                    outline: 'none',
                    boxShadow: 'none'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#045a0a';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#034807';
                }}
            >
                Connect Wallet
            </button>
        </div>
    );
}
